export default "__VITE_ASSET__CltJ6LO9__"